import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Paper, BottomNavigation, BottomNavigationAction } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import { tokens, type } from '../theme';

// Bottom tabs rather than a hamburger: there are only three user-facing sections,
// and hiding three destinations behind an unlabelled icon made Standings and
// Analytics effectively undiscoverable. The bar also sits in the thumb zone, which
// matters for an app used one-handed on the touchline.
//
// Admin is deliberately absent — it's password-gated and reachable by URL.
const TABS = [
  { label: 'Schedule', value: '/schedule', icon: <CalendarMonthIcon /> },
  { label: 'Standings', value: '/standings', icon: <LeaderboardIcon /> },
  { label: 'Analytics', value: '/analytics', icon: <ShowChartIcon /> },
  { label: 'My Team', value: '/my-team', icon: <ShieldOutlinedIcon /> },
];

export const BOTTOM_NAV_HEIGHT = 58;

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  // A team page is reached from the schedule, so keep that tab lit rather than
  // leaving the bar with nothing selected.
  const current = (() => {
    if (path === '/' || path === '/schedule' || path.startsWith('/team/')) return '/schedule';
    if (path === '/standings') return '/standings';
    if (path === '/analytics') return '/analytics';
    if (path === '/my-team') return '/my-team';
    return false;
  })();

  if (path === '/admin') return null;

  return (
    <Paper
      elevation={0}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        display: { xs: 'block', md: 'none' },
        borderTop: `1px solid ${tokens.rule}`,
        // Standalone PWA: clear the home indicator.
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <BottomNavigation
        value={current}
        onChange={(e, v) => navigate(v)}
        showLabels
        sx={{ height: BOTTOM_NAV_HEIGHT, backgroundColor: tokens.surface }}
      >
        {TABS.map(tab => (
          <BottomNavigationAction
            key={tab.value}
            label={tab.label}
            value={tab.value}
            icon={tab.icon}
            sx={{
              minWidth: 0,
              color: tokens.inkMuted,
              '&.Mui-selected': { color: tokens.navy },
              '& .MuiBottomNavigationAction-label': {
                fontSize: type.label,
                '&.Mui-selected': { fontSize: type.label, fontWeight: 700 },
              },
            }}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav;
